import { useState } from "react";
import useNotify from "hooks/useNotify";
import profileApi from "api/profile";
import { useTranslation } from "react-i18next";

function useEditNewMember({
  user = {},
  filterQuery = {},
  updateUsersResult = () => {},
}) {
  const [t] = useTranslation();
  const { notifyError, notifySuccess } = useNotify();

  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = async ({ email, firstName, lastName, ...rest }) => {
    try {
      setIsLoading(true);

      const userRatesId = Object.keys(rest.userRatesId).reduce(
        (acc, serviceId) => {
          if (
            rest.userRatesId[serviceId] &&
            Array.isArray(rest.userRatesId[serviceId])
          ) {
            acc = [...acc, ...rest.userRatesId[serviceId]];
          }
          return acc;
        },
        []
      );

      const subDomainsIds = Object.keys(rest.userDomains).reduce(
        (acc, domainId) => {
          if (
            rest.userDomains[domainId] &&
            Array.isArray(rest.userDomains[domainId])
          ) {
            acc = [...acc, ...rest.userDomains[domainId]];
          }
          return acc;
        },
        []
      );

      if (subDomainsIds.length <= 0) {
        notifyError(t("errorField", { field: t("Subdomain") }));
        return;
      }

      const payload = {
        userRatesId,
        email,
        firstName,
        lastName,
        subDomains: subDomainsIds,
      };

      await profileApi.updateAgencyTeamMemberApi(user.id, payload);
      const data = await profileApi.getAgencyTeamApi(filterQuery);
      updateUsersResult(data);
      notifySuccess(t("teamMemberUpdatedSuccessMsg"));
      setIsOpen(false);
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const onHandleDefaultValues = () => {
    let result = {
      firstName: user?.firstName ?? "",
      lastName: user?.lastName ?? "",
      email: user?.email ?? "",
      //  "serviceId-0":"33740a6d-a92f-4000-b4be-481b4a30c848"
      //  "domainId-0":"33740a6d-a92f-4000-b4be-481b4a30c848"
      userRatesId: {}, // serviceId:[userRateId]
      userDomains: {}, // domainId:[subDomainId]
    };
    let serviceRates = user?.serviceRates ?? [];

    serviceRates.forEach((item, index) => {
      result.userRatesId = {
        ...result.userRatesId,
        [item.serviceId]: result.userRatesId[item.serviceId]
          ? [...result.userRatesId[item.serviceId], item.userRateId]
          : [item.userRateId],
      };
    });

    Object.keys(result.userRatesId).forEach((serviceId, i) => {
      result[`serviceId-${i}`] = serviceId;
      result[`lang-service-${i}`] = serviceId;
    });

    let domains = user?.domains ?? [];
    domains.forEach((item, index) => {
      result[`domainId-${index}`] = item.id;
      result[`subdomain-id-${index}`] =
        item.subDomains.length > 0 ? item.id : "";

      if (!result.userDomains) {
        result.userDomains = {};
      }

      result.userDomains[item.id] = item.subDomains.map(
        (subDomain) => subDomain.id
      );
    });

    return result;
  };
  return { isOpen, setIsOpen, onSubmit, isLoading, onHandleDefaultValues };
}

export default useEditNewMember;
